import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import { isBrowserEnv } from '@nubank/www-latam-commons/utils/env/isBrowserEnv';

function DrawerPortal({ children }) {
  if (!isBrowserEnv) return null;
  const modalRoot = document.querySelector('#modal-root');
  const [drawerWrapper] = useState(document.createElement('div'));

  useEffect(() => {
    if (modalRoot) modalRoot.appendChild(drawerWrapper);

    return () => {
      if (modalRoot) modalRoot.removeChild(drawerWrapper);
    };
  }, []);

  return ReactDOM.createPortal(children, drawerWrapper);
}

export default DrawerPortal;
